import React from 'react';
import { DH } from '../../../utils/DataHook';

export const WidgetContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div data-hook={DH.WidgetContainer}>{children}</div>;
